import React, { useEffect, useState } from 'react';
import { withRouter } from '../../../../common/utils/NavigationWrapper';
import { connect } from 'react-redux';
import FleetSummary from './FleetSummary';
import Utils from '../../../../common/utils/Utils';
import { getFleets } from '../../../Fleets/components/FleetEditor/FleetEditor.actions';
import { useSearchParams } from 'react-router-dom';

const FleetSummaryContainer = (props) => {
  const [fleets, setFleets] = useState([]);

  useEffect(() => {
    getFleets().then((res) => {
      let fleetList = res.body;
      if (!fleetList || !Array.isArray(fleetList)) {
        return;
      }
      setFleets(fleetList.slice(0));
    });
  }, []);

  let currentPath = Utils.determineCurrentPath(props.location.pathname);

  function handleDropdownSelection(path) {
    props.navigate(`/fleet-details/${props.selectedFleet.fleetId}${path}`);
  }

  const _onChangeFleetSelection = (newSelectedFleet) => {
    if (newSelectedFleet == null) return;

    const { navigate, selectedFleet } = props;
    let currentUrl = props.location.pathname;
    let newUrl = currentUrl.replaceAll(selectedFleet.fleetId, newSelectedFleet.FleetId);

    navigate(newUrl + `?SelectedFleet=${newSelectedFleet.FleetId}`);
  };

  return (
    <FleetSummary
      {...props}
      currentPath={currentPath}
      onChange={handleDropdownSelection}
      fleets={fleets}
      onChangeFleetSelection={_onChangeFleetSelection}
    />
  );
};

const mapStateToProps = (state) => ({
  globalSettings: state.user ? state.user.Settings : undefined,
});

export default withRouter(connect(mapStateToProps)(FleetSummaryContainer));
